module.exports = "<p *ngIf=\"message\" [ngClass]=\"message.cssClass\">{{message.text}}</p>\n"